<script setup lang="ts">
import { IonAccordionGroup } from '@ionic/vue';
</script>

<template>
	<ion-accordion-group class="w-full mb-4 backdrop-blur-xl bg-white/10 rounded-lg">
		<slot />
	</ion-accordion-group>
</template>

<style scoped></style>
